import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Transferencias from "./Transferencias/index.js";
import { API_FINANZAS } from "../../shared/services/finanzas.js";
import { setErrorMessage } from "../../shared/helpers/functionalities.js";
import { toast } from "react-toastify";

export default function Pagos() {
    const dispatch = useDispatch();
    const [transferencias, setTransferencias] = useState([]);

    useEffect(() => {
        const fetchFinanzas = async() => {
            dispatch({ type: 'loading/set', payload: true })
            const response = await API_FINANZAS.getPagos()
            .catch(error => {
                toast.error(setErrorMessage(error))
                dispatch({ type: 'loading/set', payload: false })
            })

            setTransferencias(response.data)
            dispatch({ type: 'loading/set', payload: false })
        }

        fetchFinanzas();
    }, []);

    const updateTransferencias = (checkoutId) => {
        const newTransferencias = transferencias.filter(p => p.checkout_id !== checkoutId);
        setTransferencias(newTransferencias);
    }

    return (
        <div className="w-100 d-flex flex-column align-items-end">
            <div className='w-100 mb-4'>
                <h6 className="fw-bold">Transferencias pendientes de aprobación</h6>

                <div className='w-100'>
                    { transferencias?.length > 0 ?
                        <Transferencias 
                            presupuestos={transferencias}
                            onDoneAction={updateTransferencias}
                        />

                        : <small>No hay transferencias para aprobar.</small>
                    }
                </div>
            </div>
        </div>
    );
}